import React from 'react';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import {
    selectUser
} from 'store/user';
import {
    User
} from 'model/index';
import { useNavigate, Navigate } from '@tanstack/react-router';
import LobbyPage from './Lobby';
const Lobby: React.FC = () => {
    const user: User = useAppSelector(selectUser);
    React.useEffect(() => {
        document.title = `Lobby | ${globalThis.showTitle}`;
    }, []);
    if (user.page && user.page.length > 0) {
        switch (user.page) {
            case "lobby":
                return <LobbyPage />;
            case "order":
                return <Navigate to="/order" />;
            case "instructions":
                return <Navigate to="/instructions" />;
            case "show-info":
                return <Navigate to="/show-info" />;
            case "order-summary":
                return <Navigate to="/order-summary" />;
            default:
                return <LobbyPage />;
        }
    } else {
        return (
            <LobbyPage />
        );
    }
};

export default Lobby;